/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { getData, postData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { reactSelectStyle } from "Config/Config";

const AiRecommendationPopup = ({selectedLeadIds='',
  selectedLeadEmails,
  setSelectedLeadEmails,
  subject,
  setSubject,
  content,
  setContent,
}) => {
  const token = localStorage.getItem("token");

  const { t } = useTranslation();
  const offcanvasBodyRef = useRef(null);

  const [companyList, setCompanyList] = useState([]);
  const [companyInput, setCompanyInput] = useState("");
  const [companyValue, setCompanyValue] = useState(null);
  const [selectedCompanyInfo, setSelectedCompanyInfo] = useState('');
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);

  const [goalOptions, setGoalOptions] = useState([]);
  const [goalValue, setGoalValue] = useState(null);
  const [allGoals, setAllGoals] = useState([]); // Store all goal objects
  const [selectedGoalInfo, setSelectedGoalInfo] = useState(null); // Store selected goal info

  const [aiPrompt, setAIPrompt] = useState("");
  const [defaultAIPrompt, setDefaultAIPrompt] = useState(""); // Store the default prompt
  const [isLoadingGoals, setIsLoadingGoals] = useState(false);

  const [errors, setErrors] = useState({});

  const [aiResults, setAiResults] = useState({}); // Map leadId -> result
  const [isGenerating, setIsGenerating] = useState(false);

  const [aiRecommendationPrompt, setAiRecommendationPrompt] = useState("");

  const [showPromptAccordion, setShowPromptAccordion] = useState(false);
  // NEW: state for call modal
  const [callModalData, setCallModalData] = useState(null);

  // Dummy leads array for demonstration; replace with actual leads data as needed
  const leads = [
    { name: "John Doe", role: "Manager", company: "ABC Corp" },
    { name: "Jane Smith", role: "Director", company: "XYZ Ltd" },
    // ...add more leads as needed
  ];

  // Fetch companies as user types
  useEffect(() => {
    if (companyInput.length > 1) {
      getAllCompanyList();
    }
  }, [companyInput]);

  // Fetch goals when company changes
  useEffect(() => {
    if (selectedCompanyId) {
      fetchCompanyGoals(selectedCompanyId);
    } else {
      setGoalOptions([]);
      setGoalValue(null);
    }
  }, [selectedCompanyId]);

  // NEW: effect to auto-open modal when data set.
  useEffect(() => {
    if (callModalData) {
      const modalEl = document.getElementById('aiCallScriptModal');
      if (modalEl) {
        const bsModal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        bsModal.show();
      }
    }
  }, [callModalData]);

  // get all company list owner by user -------
  const getAllCompanyList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?token=${token}&filtername=${companyInput}`;
      const response = await getData(requestUrl);

      console.log("Company List Response:", response);

      if (response.status) {
        setCompanyList(response.data);
      }
    } catch (error) {
      setCompanyList([]);
    }
  };

  // get the goals associated with the selected company
  const fetchCompanyGoals = async (companyId) => {
    setIsLoadingGoals(true);
    setGoalOptions([]);
    setAllGoals([]);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_COMPANY_GOALS +
        `?token=${token}&company=${companyId}`;

      const response = await getData(requestUrl);

      console.log("Goals Response:", response);

      if (response.status) {
        setAllGoals(response.data); // Save all goal objects
        setGoalOptions(
          response.data.map((goal) => ({
            value: goal._id,
            label: goal.name,
          }))
        );
      }
    } catch (error) {
      setGoalOptions([]);
      setAllGoals([]);
    }
    setIsLoadingGoals(false);
  };

  // selection handler
  const companySelectionHandler = (val) => {

    console.log('company selection', val);

    setCompanyValue(val);
    setSelectedCompanyId(val ? val.value : null);
    setErrors((prev) => ({ ...prev, company: "" }));

    setSelectedCompanyInfo(val?.summary??'');
  
  };

  // goal selection handler
  const goalSelectionHandler = (val) => {
    setGoalValue(val);
    setErrors((prev) => ({ ...prev, goal: "" }));
    if (val && allGoals.length > 0) {
      const found = allGoals.find((g) => g._id === val.value);
      setSelectedGoalInfo(found || null);

      // Updated prompt template as per instructions
      if (found) {
        const prompt = `You are an assistant that analyzes leads for business objectives.
      Company Profile:
      ${selectedCompanyInfo}
      Objective:
      ${found.description || "{objective}"}
      Industry Focus:
      ${
        found.targetindustry && found.targetindustry.length > 0
          ? found.targetindustry.join(", ")
          : "{industry}"
      }
      Available Actions:
      ${
        found.availableactions
          ? Object.entries(found.availableactions)
              .filter(([k, v]) => v === true)
              .map(([k]) => k)
              .join(", ")
          : "{available_actions}"
      }
      Lead Information: %lead_information%
      Instructions:
      Analyze if this lead is relevant and useful for the objective.
      `;

        setDefaultAIPrompt(prompt);
        setAIPrompt(prompt);

      } else {
        setDefaultAIPrompt("");
        setAIPrompt("");
      }
    } else {
      setSelectedGoalInfo(null);
      setDefaultAIPrompt("");
      setAIPrompt("");
    }
  };

  // reset handler
  const resetHandler = () => {
    setCompanyValue(null);
    setGoalValue(null);
    setAIPrompt("");
    setErrors({});
    setAiResults({});
    setSelectedCompanyId(null);
    setSelectedCompanyInfo('');
    setSelectedGoalInfo(null);
  };


  // Generate AI recommendation ---------
  const handleGenerate = async () => {

    const newErrors = {};

    if (!companyValue) newErrors.company = t("Please select a company.");
    if (!goalValue) newErrors.goal = t("Please select a company goal.");
    if (!aiPrompt.trim()) newErrors.aiPrompt = t("Please enter an AI prompt.");

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      if (offcanvasBodyRef.current) {
        offcanvasBodyRef.current.scrollTo({ top: 0, behavior: "smooth" });
      }
      return;
    }

    setIsGenerating(true);
    setAiResults({}); // Clear previous results

    const requestUrl = url.API_BASE_URL + url.API_AI_LEAD_RECOMMENDATION + `?token=${token}`;

    if (selectedLeadIds && selectedLeadIds.length > 0) {
      setAiResults({}); // Clear previous results

      for (const leadid of selectedLeadIds) {
        const payload = {
          companyId: selectedCompanyId,
          goalId: (goalValue ? goalValue.value : null),
          prompt: aiPrompt,
          leadId: leadid
        };

        // Show placeholder immediately for this lead
        setAiResults(prev => ({ ...prev, [leadid]: null }));

        const response = await postData(requestUrl, payload);

        console.log("AI Recommendation Response for lead", response);

        if (response.status) {
          setAiResults(prev => ({
            ...prev,
            [leadid]: { recommendation: response.recommendation, lead: response.data }
          }));
        } else {
          setAiResults(prev => ({
            ...prev,
            [leadid]: { error: true }
          }));
        }
      }
    }
    setIsGenerating(false);
  };

  // Save AI results API call
  const handleSaveAiResults = async () => {
    

  }

  // NEW: close handler for call modal
  const handleCloseCallModal = () => {
    setCallModalData(null);
    const modalEl = document.getElementById('aiCallScriptModal');
    if (modalEl) {
      const bsModal = window.bootstrap.Modal.getInstance(modalEl);
      if (bsModal) bsModal.hide();
    }
  };

  // Custom styles for react-select to show validation error
  const customCompanyStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.company ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.company ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    ...reactSelectStyle("3px", "6px", true, false),
  };

  const customGoalStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.goal ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.goal ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    ...reactSelectStyle("3px", "6px", true, false),
  };

  return (
    <>
      <div
        className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
        tabIndex="-1"
        id="aiRecommendationPopup"
        aria-labelledby="aiRecommendationPopupLabel"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
          <div className="d-flex align-items-center gap-3">
            <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
              <span className="material-symbols-outlined text-primary fs-5 icon-md">
                smart_toy
              </span>
            </div>
            <div>
              <h3
                className="offcanvas-title fw-bold text-white mb-0"
                id="aiRecommendationPopupLabel"
              >
                {t("AI Recommendation")}
              </h3>
              <p className="text-white fs-sm mb-0">
                {t("Select company, goal and enter your AI prompt")}
              </p>
            </div>
          </div>
          <button
            type="button"
            className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            //onClick={resetHandler}
          ></button>
        </div>
        <div className="offcanvas-body p-4" ref={offcanvasBodyRef}>
          <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
            <form
              onSubmit={(e) => e.preventDefault()}
              className="d-flex flex-column h-100"
            >
              <div className="fields-container flex-fill">
                {/* Company and Company Goals in one row */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <div className="row align-items-start">
                    {/* Company */}
                    <div className="col-md-6 mb-3 mb-md-0">
                      <label
                        htmlFor="companyStore"
                        className="d-block fs-sm fw-semibold text-dark mb-2"
                      >
                        {t("Company")} <span className="text-danger">*</span>
                      </label>
                      <div className="d-flex align-items-center gap-2">
                        <div style={{ flex: 1 }}>
                          <Select
                            isClearable
                            className={`w-100 ${
                              errors.company ? "is-invalid" : ""
                            }`}
                            placeholder={t(
                              "Search and select the associated company or store"
                            )}
                            options={companyList}
                            value={companyValue}
                            onChange={companySelectionHandler}
                            onInputChange={(val) => setCompanyInput(val)}
                            styles={customCompanyStyles}
                          />
                        </div>
                        <button
                          type="button"
                          className="btn btn-sm btn-light border d-flex align-items-center gap-1 px-2 py-1 bg-primary text-white"
                          style={{ fontSize: "13px" }}
                          title={t("Add New Company")}
                          onClick={() =>
                            window.open("/admin/companies/info", "_blank")
                          }
                        >
                          <span
                            className="material-symbols-outlined"
                            style={{ fontSize: "18px" }}
                          >
                            add
                          </span>
                        </button>
                      </div>
                      {errors.company && (
                        <div className="invalid-feedback d-block mt-2">
                          {errors.company}
                        </div>
                      )}
                      {/* Show selected company info */}
                      {selectedCompanyInfo && (
                        <div className="mt-3 p-3 border rounded-8 bg-light">
                          <strong>{t("Company Profile")}:</strong>{" "}
                          <span>{selectedCompanyInfo}</span>
                        </div>
                      )}
                    </div>
                    {/* Company Goal - only show if company is selected */}
                    {selectedCompanyId && (
                      <div className="col-md-6">
                        <label
                          htmlFor="companyGoal"
                          className="d-block fs-sm fw-semibold text-dark mb-2"
                        >
                          {t("Company Goal")}{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="d-flex align-items-center gap-2">
                          <div style={{ flex: 1 }}>
                            <Select
                              isClearable
                              className={`w-100 ${
                                errors.goal ? "is-invalid" : ""
                              }`}
                              placeholder={t(
                                "Select a goal for the selected company"
                              )}
                              options={goalOptions}
                              value={goalValue}
                              onChange={goalSelectionHandler}
                              isLoading={isLoadingGoals}
                              styles={customGoalStyles}
                              isDisabled={!selectedCompanyId}
                            />
                          </div>
                          <button
                            type="button"
                            className="btn btn-sm btn-light border d-flex align-items-center gap-1 px-2 py-1 bg-primary text-white"
                            style={{ fontSize: "13px" }}
                            title={t("Add New Goal")}
                            onClick={() =>
                              window.open(
                                `/admin/companies/goals/${selectedCompanyId}`,
                                "_blank"
                              )
                            }
                          >
                            <span
                              className="material-symbols-outlined"
                              style={{ fontSize: "18px" }}
                            >
                              add
                            </span>
                          </button>
                        </div>
                        {errors.goal && (
                          <div className="invalid-feedback d-block mt-2">
                            {errors.goal}
                          </div>
                        )}
                        {/* Show selected goal info */}
                        {selectedGoalInfo && (
                          <div className="mt-3 p-3 border rounded-8 bg-light">
                            {selectedGoalInfo.description && (
                              <div className="mb-2">
                                <strong>{t("Objective")}:</strong>{" "}
                                <span>{selectedGoalInfo.description}</span>
                              </div>
                            )}
                            {selectedGoalInfo.targetindustry &&
                              selectedGoalInfo.targetindustry.length > 0 && (
                                <div className="mb-2">
                                  <strong>{t("Target Industry")}:</strong>{" "}
                                  <span>
                                    {selectedGoalInfo.targetindustry.join(", ")}
                                  </span>
                                </div>
                              )}
                            {selectedGoalInfo.availableactions &&
                              typeof selectedGoalInfo.availableactions ===
                                "object" && (
                                <div className="mb-2">
                                  <strong>{t("Available Actions")}:</strong>{" "}
                                  <span>
                                    {Object.entries(
                                      selectedGoalInfo.availableactions
                                    )
                                      .filter(([k, v]) => v === true)
                                      .map(([k]) => k)
                                      .join(", ")}
                                  </span>
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {/* AI Prompt */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="aiPrompt"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("AI Prompt")} <span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="aiPrompt"
                    rows="6"
                    className={`form-control fs-sm shadow-none ${
                      errors.aiPrompt ? "is-invalid" : "border border-gray-300"
                    }`}
                    placeholder={t("Enter your AI prompt or question here...")}
                    value={aiPrompt}
                    onChange={(e) => {
                      setAIPrompt(e.target.value);
                      if (errors.aiPrompt) {
                        setErrors((prev) => ({ ...prev, aiPrompt: "" }));
                      }
                    }}
                  ></textarea>
                  {errors.aiPrompt && (
                    <div className="invalid-feedback d-block mt-2">
                      {errors.aiPrompt}
                    </div>
                  )}
                  {/* Accordion for Current AI Prompt */}
                  {aiPrompt && (
                    <div className="mt-3">
                      <button
                        type="button"
                        className="btn btn-link d-flex align-items-center p-0"
                        style={{ textDecoration: "none" }}
                        onClick={() => setShowPromptAccordion((prev) => !prev)}
                      >
                        <span
                          className="material-symbols-outlined me-1"
                          style={{
                            transition: "transform 0.2s",
                            transform: showPromptAccordion
                              ? "rotate(90deg)"
                              : "rotate(0deg)",
                          }}
                        >
                          chevron_right
                        </span>
                        <span>{t("Current AI Prompt")}</span>
                      </button>
                      {showPromptAccordion && (
                        <div className="mt-2 p-3 border rounded-8 bg-light">
                          <pre
                            style={{ whiteSpace: "pre-wrap", marginBottom: 0 }}
                          >
                            {aiPrompt}
                          </pre>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* AI Results Table */}
              <div className="action d-flex justify-content-end align-items-center gap-2 pt-3 border-top mt-auto">
                {/* New label added here */}
                <span
                  className="fw-semibold text-primary me-auto"
                  style={{ fontSize: "16px" }}
                >
                  Recommendation on selected Leads
                </span>
                <button
                  type="button"
                  className="btn btn-light d-flex align-items-center gap-2"
                  style={{ cursor: isGenerating ? "not-allowed" : "pointer" }}
                  onClick={resetHandler}
                  disabled={isGenerating}
                >
                  <span className="material-symbols-outlined me-1">
                    restart_alt
                  </span>
                  {t("Reset")}
                </button>
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center gap-2"
                  style={{ cursor: isGenerating ? "not-allowed" : "pointer" }}
                  onClick={handleGenerate}
                  disabled={isGenerating}
                >
                  <span className="material-symbols-outlined me-1">
                    smart_toy
                  </span>
                  {isGenerating ? t("Generating...") : t("Generate Result")}
                </button>
              </div>

              {/* AI results on recommendation */}
              {(isGenerating || Object.keys(aiResults).length > 0) &&
                selectedLeadIds &&
                selectedLeadIds.length > 0 && (
                  <div className="mt-2">
                    <table className="table table-bordered table-hover table-sm align-middle">
                      <thead className="table-light">
                        <tr>
                          <th className="text-center">{t("Lead")}</th>
                          <th className="text-center">{t("Is Useful")}</th>
                          <th className="text-center">{t("Reason")}</th>
                          <th className="text-center">
                            {t("Recommended Action")}
                          </th>
                          <th className="text-center">{t("Action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedLeadIds.map((leadid, idx) => {
                          const row = aiResults[leadid];
                          if (row && row.error) {
                            return (
                              <tr key={leadid}>
                                <td
                                  colSpan={5}
                                  className="text-danger text-center"
                                >
                                  {t("Error fetching result")}
                                </td>
                              </tr>
                            );
                          }
                          if (row && row.recommendation) {
                            const isUseful = row.recommendation?.isUseful;
                            return (
                              <tr key={leadid}>
                                <td className="text-center fw-semibold">
                                  {row.lead
                                    ? `${row.lead.customid} - ${row.lead.name}`
                                    : ""}
                                </td>
                                <td className="text-center">
                                  {isUseful ? (
                                    <span className="badge bg-success">
                                      {t("Yes")}
                                    </span>
                                  ) : (
                                    <span className="badge bg-danger">
                                      {t("No")}
                                    </span>
                                  )}
                                </td>
                                <td className="text-center">
                                  {row.recommendation?.reason}
                                </td>
                                <td className="text-center">
                                  {row.recommendation?.recommendedAction}
                                </td>
                                <td className="text-center">
                                  {isUseful ? (
                                    <>
                                      {row.recommendation?.recommendedAction ===
                                        "sendmail" && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-primary px-3"
                                          style={{ minWidth: "100px" }}
                                          onClick={() => {
                                            if (row.lead && row.lead.email) {
                                              setSelectedLeadEmails([
                                                row.lead.email,
                                              ]);

                                              // NEW: pass AI-generated subject and content to parent
                                              const mailSubject =
                                                row.recommendation
                                                  ?.mailSubject ?? "";
                                              const mailContent =
                                                row.recommendation
                                                  ?.mailContent ?? "";
                                              if (
                                                typeof setSubject === "function"
                                              )
                                                setSubject(mailSubject);
                                              if (
                                                typeof setContent === "function"
                                              )
                                                setContent(mailContent);

                                              // Hide AI Recommendation offcanvas
                                              const aiOffcanvas =
                                                document.getElementById(
                                                  "aiRecommendationPopup"
                                                );
                                              if (aiOffcanvas) {
                                                const bsOffcanvas =
                                                  window.bootstrap.Offcanvas.getInstance(
                                                    aiOffcanvas
                                                  );
                                                if (bsOffcanvas)
                                                  bsOffcanvas.hide();
                                              }
                                              // Show send mail offcanvas
                                              const mailOffcanvas =
                                                document.getElementById(
                                                  "offcanvasNewMail"
                                                );
                                              if (mailOffcanvas) {
                                                const bsMailOffcanvas =
                                                  window.bootstrap.Offcanvas.getOrCreateInstance(
                                                    mailOffcanvas
                                                  );
                                                bsMailOffcanvas.show();
                                              }
                                            } else {
                                              alert(
                                                t(
                                                  "No email found for this lead."
                                                )
                                              );
                                            }
                                          }}
                                        >
                                          {t("Send Mail")}
                                        </button>
                                      )}
                                      {row.recommendation?.recommendedAction ===
                                        "call" && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-warning px-3"
                                          style={{ minWidth: "100px" }}
                                          onClick={() => {
                                            if (row.lead) {
                                              setCallModalData({
                                                name: row.lead.name,
                                                phone: row.lead.phone,
                                                script:
                                                  row.recommendation
                                                    ?.callScript ||
                                                  row.recommendation?.script ||
                                                  "",
                                                reason:
                                                  row.recommendation?.reason ||
                                                  "",
                                              });
                                            } else {
                                              alert(
                                                t(
                                                  "No phone number found for this lead."
                                                )
                                              );
                                            }
                                          }}
                                        >
                                          {t("Call")}
                                        </button>
                                      )}
                                      {row.recommendation?.recommendedAction ===
                                        "addtag" && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-info px-3"
                                          style={{ minWidth: "100px" }}
                                          onClick={() => {
                                            // Hide AI Recommendation offcanvas
                                            const aiOffcanvas =
                                              document.getElementById(
                                                "aiRecommendationPopup"
                                              );
                                            if (aiOffcanvas) {
                                              const bsOffcanvas =
                                                window.bootstrap.Offcanvas.getInstance(
                                                  aiOffcanvas
                                                );
                                              if (bsOffcanvas)
                                                bsOffcanvas.hide();
                                            }
                                            // Show Add Label modal
                                            const addLabelModal =
                                              document.getElementById(
                                                "addLabelModal"
                                              );
                                            if (addLabelModal) {
                                              const bsModal =
                                                window.bootstrap.Modal.getOrCreateInstance(
                                                  addLabelModal
                                                );
                                              bsModal.show();
                                            }
                                            // Optionally set selected lead id/email if needed
                                            setSelectedLeadEmails([
                                              row.lead.email,
                                            ]);
                                          }}
                                        >
                                          {t("Add Tag")}
                                        </button>
                                      )}
                                      {/* fallback if recommendedAction is not recognized */}
                                      {!["sendmail", "call", "addtag"].includes(
                                        row.recommendation?.recommendedAction
                                      ) && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-secondary px-3"
                                          style={{ minWidth: "100px" }}
                                          disabled
                                        >
                                          {t("Take Action")}
                                        </button>
                                      )}
                                    </>
                                  ) : (
                                    <span
                                      className="text-danger fs-4"
                                      title={t("Not Useful")}
                                    >
                                      &#10006;
                                    </span>
                                  )}
                                </td>
                              </tr>
                            );
                          }
                          // Glow placeholder row
                          return (
                            <tr key={leadid}>
                              <td colSpan={5}>
                                <div className="placeholder-glow">
                                  <span
                                    className="placeholder col-12"
                                    style={{ height: "1.5em" }}
                                  ></span>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div className="d-flex justify-content-end mt-2">
                      {/* <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleSaveAiResults}
                      disabled={isGenerating}
                    >
                      {t("Save Results")}
                    </button> */}
                    </div>
                  </div>
                )}
            </form>
          </div>
        </div>
      </div>

      {/* Modal moved OUTSIDE offcanvas for proper backdrop layering */}
      <div
        className="modal fade"
        id="aiCallScriptModal"
        tabIndex="-1"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content rounded-10 shadow">
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title d-flex align-items-center gap-2">
                <span className="material-symbols-outlined">call</span>
                {t("Call Script")}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={handleCloseCallModal}
              ></button>
            </div>
            <div className="modal-body">
              {callModalData && (
                <>
                  <div className="mb-3">
                    <div className="fw-semibold">{t("Lead Name")}:</div>
                    <div>{callModalData.name}</div>
                  </div>
                  <div className="mb-3">
                    <div className="fw-semibold">{t("Phone")}:</div>
                    <a
                      href={`tel:${callModalData.phone}`}
                      className="text-decoration-none"
                    >
                      {callModalData.phone}
                    </a>
                  </div>
                  <div className="mb-3">
                    <div className="fw-semibold">{t("Reason")}:</div>
                    <div>
                      {callModalData.reason || t("No reason provided.")}
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="fw-semibold mb-2">
                      {t("Suggested Script")}:
                    </div>
                    <div
                      className="p-3 bg-light border rounded-8"
                      style={{ whiteSpace: "pre-wrap", minHeight: "120px" }}
                    >
                      {callModalData.script || t("No script provided.")}
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => {
                  if (callModalData?.script) {
                    navigator.clipboard.writeText(callModalData.script);
                  }
                }}
              >
                <span
                  className="material-symbols-outlined align-middle me-1"
                  style={{ fontSize: "18px" }}
                >
                  content_copy
                </span>
                {t("Copy Script")}
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => {
                  if (callModalData?.phone) {
                    window.open(`tel:${callModalData.phone}`, "_self");
                  }
                }}
              >
                <span
                  className="material-symbols-outlined align-middle me-1"
                  style={{ fontSize: "18px" }}
                >
                  call
                </span>
                {t("Start Call")}
              </button>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={handleCloseCallModal}
              >
                {t("Close")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Backdrop / z-index fix */}
      {/* <style>
        {`
          .modal-backdrop.show { z-index: 1060 !important; }
          #aiCallScriptModal { z-index: 1065 !important; }
          .offcanvas { z-index: 1045; }
        `}
      </style> */}
    </>
  );
};

export default AiRecommendationPopup;
